import { useTranslation } from 'react-i18next'
import { Box, Button, Grid, Typography } from '@mui/material'
import PropTypes from 'prop-types'

import PublicAppBar from '@/common/components/MainAppBar/PublicAppBar'

const classes = {
    sorryImage: {
        width: '700px',
    },
    sorryMessage: {
        gap: 1,
    },
}

const ErrorPageContainer = ({ linkHref, linkText, subtitle, title }) => {
    const { t } = useTranslation()

    return (
        <>
            <PublicAppBar />
            <Grid
                component="section"
                flex={1}
                justifyContent="center"
                size={12}
                container
            >
                <Box
                    sx={[
                        {
                            alignItems: 'center',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            p: 12,
                        },
                        classes.root,
                    ]}
                >
                    <Box
                        alt="Sorry"
                        component="img"
                        src="sorry.svg"
                        sx={classes.sorryImage}
                    />

                    <Box
                        sx={[
                            {
                                alignItems: 'center',
                                display: 'flex',
                                flexDirection: 'column',
                                justifyContent: 'center',
                            },
                            classes.sorryMessage,
                        ]}
                    >
                        <Typography variant="h4">{t(title)}</Typography>
                        <Typography variant="body2">{t(subtitle)}</Typography>
                    </Box>

                    <Button
                        color="primary"
                        size="large"
                        variant="contained"
                        onClick={() => {
                            window.location.href = linkHref
                        }}
                    >
                        {t(linkText)}
                    </Button>
                </Box>
            </Grid>
        </>
    )
}

ErrorPageContainer.propTypes = {
    linkHref: PropTypes.string,
    linkText: PropTypes.string,
    subtitle: PropTypes.string,
    title: PropTypes.string,
}

export default ErrorPageContainer
